import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class MetricsAddBlockTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.METRICS_ADD_BLOCK;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_METRICS_ADD_BLOCK;

	get id(): string {
		return TourId.METRICS_ADD_BLOCK;
	}

	override get keyForPersistantDone(): string {
		return MetricsAddBlockTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				attachTo: () => {
					return $('.source-metric-popup').find('a.action').eq(0);
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
